import styled from "styled-components";

export const ThisCard = styled.div`
  cursor: pointer;
  box-shadow: ${localStorage.getItem("tema") == "E" ? "0px 0px 19px 0px rgb(4 4 4 / 25%)" : "0px 0px 20px rgba(242, 247, 249,15)"} !important;
`;